// extracted by mini-css-extract-plugin
export default {"TableauBootstrap":"AddCapteurComposante_TableauBootstrap__8W29K","btn_stylo":"AddCapteurComposante_btn_stylo__BduLd"};